








































































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import numeral from "numeral";

import { Currency } from "@/utils/currency";
import { CartPackages, lacs } from "@/interfaces/packages/sales_packages";
import DatePickerComponent from "@/components/controls/DatePickerComponent.vue";

const defaultFormat = "0,0";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class CartItemsTable extends Vue {
  @Prop({ required: true })
  canEdit!: boolean;

  @Prop({ required: true })
  packagesInCart!: CartPackages[];

  @Prop({ required: true })
  currency!: string;

  @Prop({ required: false })
  minimumDate!: string;

  @Prop()
  removingPackage!: boolean;

  @Prop()
  itemClicked!: string;

  @Prop({ required: true })
  numberFormat!: string;

  @Prop({ default: "" })
  taxMessage!: string;

  get currencyText() {
    // If is default format, return nothing
    if (defaultFormat === this.numberFormat) {
      return "";
    }
    return this.numberFormat;
  }

  get isLacsFormat() {
    return lacs === this.numberFormat;
  }

  get totalAdditionalText() {
    if (Currency.MYR === this.currency) {
      // As discussed, we will check for MYR currency for now.
      return " (exclusive of 6% SST)";
    }
    return this.taxMessage || "";
  }

  convertRupeeToLacs(value: number) {
    /* India event prefers format of "INR 1.32 lacs" instead of "INR 132,000" */
    return numeral(value / 100000).format("0.00");
  }

  convertNumeral(value: number) {
    if (this.isLacsFormat) {
      return this.convertRupeeToLacs(value);
    }
    return numeral(value).format(defaultFormat);
  }

  totalPrice() {
    const totalAmount = this.packagesInCart.reduce(
      (total, current) => total + current.package.price,
      0
    );
    if (this.isLacsFormat) {
      return this.convertRupeeToLacs(totalAmount);
    }
    return numeral(totalAmount).format(defaultFormat);
  }

  @Emit()
  updateDates(value: string, item: CartPackages) {
    return { value, item };
  }

  @Emit()
  removePackage(item: CartPackages) {
    return item;
  }
}
